import { useEffect, useState } from 'react';
import { Modal } from '@mui/material';
import { Box } from '@mui/system';
import Button from '@mui/material/Button';
import H6 from './H6';
import Subtitle1 from './Subtitle1';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  boxShadow: '0px 0px 4px 1px #383838',
  p: 4,
  borderRadius: '10px',
};

export default function ConfirmationDialog({
  openDialog,
  title,
  message,
  yesHandler,
  data,
}) {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    // eslint-disable-next-line no-param-reassign
    openDialog.show = false;
    setOpen(false);
  };
  const handleConfirm = () => {
    setOpen(false);
    // eslint-disable-next-line no-param-reassign
    openDialog.show = false;
    yesHandler(data);
  };

  useEffect(() => {
    setOpen(openDialog.show ? openDialog.show : false);
  }, [openDialog]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <H6 id="modal-modal-title">{title}</H6>
        <Subtitle1
          id="modal-modal-description"
          sx={{ mt: 2 }}>
          {message}
        </Subtitle1>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            columnGap: '5px',
            marginTop: '20px',
          }}>
          <Button
            variant="outlined"
            onClick={handleClose}>
            No
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}>
            Yes
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
